<template>
  <div>
    <div class="w3-row">
      <div class="w3-col" :class="hideSidebar ? 'm12' : 'm8'">
        <!-- Welcome Page -->
        <div v-if="advertisersView == 'defaultView' || advertisersView == 'userView' && user && !user.types.advertiser" class="animateUp">
          <img :alt="'header image'" src="../assets/images/header2.jpg" style="width:100%; padding:0 4px 8px" />
          <div class="sectionHeader">
            <h5>Welcome Advertisers and Local Business Owners</h5>
          </div>
          <div style="padding:0 4px 8px;">
            <div class="whiteContainer">
              <p>
                <b>Daytona</b><span class="loGreen">Local</span>.com provides <b>marketers and local business</b> owners with <b>direct access to 
                local event, attraction and restaurant pages</b>. Connect directly with your target audience by searching for local events and 
                advertising only on the pages that make sense to you. Upload your own banner or use our Ad Builder to create a high 
                quality ad. <b>Use the register button to get started</b> or <a href="/support">contact us</a> if you need assistance with setting up an account.
              </p>
              <h5 style="font-weight:bold;">Advertising FAQs</h5>
              <p>Q. <b>How much does it cost?</b><br/>
              A. The cost to advertise on an event page is just $2 per day. Set your own budget by choosing the start date, at least one day prior to the event date. 
              We also offer a sitewide global display ad at a fixed cost of $49 per month. Global ads are show on all other pages (not event pages).</p>
              <p>Q. <b>Do I need to have an ad designed?</b><br/>
              We support uploading your own image for your ad, or if you don't wish to use an image we also provide a custom Ad Builder, which allows you to create a high quality text advertisement for our site.</p>
              <p>Q. <b>How do I know if my ad performs well?</b><br/>
              We offer an integrated tracking dashboard, so you can see how many clicks your ad received over the past day, week, month or lifetime.</p>
              <p>Q. <b>Is it free to register?</b><br/>
              Yes! Registration is FREE and only requires some basic info and an email address. Once registered you'll have access to our ad builder where you can upload your designs or create an ad, check out event pages available for advertising and more.</p>
              <!-- <p>By registering you confirm that you have read and agree to our <a href="/terms#advertising">advertising terms of service</a>.</p> -->
            </div>
          </div>
        </div>
        <!-- My Ads Page -->
        <div v-if="userAds && advertisersView == 'userView' && user && user.types.advertiser">
          <img :alt="'header image'" src="../assets/images/header2.jpg" style="width:100%; padding:0 4px 8px" />
          <template v-if="width < 601">
            <!-- Advertiser Area -->
            <template v-if="user && user.types.advertiser">
              <div class="sectionHeader w3-center">
                <h5>Ad Management</h5>
              </div>
              <div class="whiteContainer" style="margin:0 4px 8px;">
                <button @click="pageNav('ad-input')" class="w3-button w3-block w3-green">
                  <span>Start New Ad</span>
                </button>
              </div>
            </template>
          </template>
          <div v-if="userAds.length > 0">
            <div class="sectionHeader">
              <h5>My Ads</h5>
            </div>
            <template v-if="width > 600">
              <div class="flowGrid w3-border-0 ad6col w3-dark-blue-grey" style="padding:8px; margin: 0 4px 8px;">
                <div>Title</div>
                <div class="w3-center">Placement</div>
                <div class="w3-center">Started</div>
                <div class="w3-center">Renews</div>
                <div class="w3-center">Status</div>
                <div class="w3-center">Actions</div>
              </div>
            </template>
            <div class="flowGrid ad6col whiteContainer" v-for="(ad, index) of userAds" :key="index">
              <div class="rowHeight adTitle">{{ad.title}}</div>
              <div class="w3-center rowHeight adPlacement"><span v-if="width < 600">Type: </span>{{ad.placement | capitalize}}</div>
              <div class="w3-center rowHeight adStart"><span v-if="width < 600">Start: </span>{{ad.start | date('shortDate')}}</div>
              <div class="w3-center rowHeight adEnd"><span v-if="width < 600"><template v-if="ad.placement === 'global'">Renews: </template><template v-else>End: </template></span>{{ad.end | date('shortDate')}}</div>
              <div class="w3-center rowHeight adStatus"><span v-if="width < 600">Status: </span>{{ad.status || 'Unknown'}}</div>
              <div class="w3-center adButtons">
                <button class="w3-button w3-dark-grey w3-small" @click="adAnalytics(ad.id)"><font-awesome-icon icon="chart-bar"></font-awesome-icon></button>
                <button class="w3-button w3-blue w3-small" @click="editAd(ad.id)"><font-awesome-icon icon="pencil-alt"></font-awesome-icon></button>
                <button class="w3-button w3-red w3-small" @click="removeAd(ad)"><font-awesome-icon icon="trash"></font-awesome-icon></button>
              </div>
            </div>
          </div>
          <div v-else>
            <div class="whiteContainer">
              <p>No Ads yet, start a new advertisement using the "Start New Ad" Button</p>
            </div>
          </div>
        </div>

        <!-- Analytics Page -->
        <div v-if="userAds && advertisersView == 'ad-analytics'">
          <analytics v-on:exit="exit()"></analytics>
        </div>

        <!-- Start New Ad Page -->
        <div v-if="userAds && advertisersView === 'ad-input'">
          <template v-if="!showPreview">
            <button class="w3-button w3-red w3-left" style="margin:0 4px;" @click="exit()">Exit</button>
            <button v-if="stepsObj.step1" class="w3-button w3-blue w3-left" style="margin:0 4px;" @click="backStep()">Back</button>
            
            <button class="w3-button w3-green w3-right" style="margin-right:4px;" v-if="stepsObj.step1 && !stepsObj.step2 && errorMessage === ''" @click="saveAd()">Continue</button>
            <button class="w3-button w3-red w3-right" style="margin-right:4px;" v-if="stepsObj.step1 && !stepsObj.step2 && errorMessage !== ''">{{errorMessage}}</button>
            <template v-if="ad.placement === 'global'">
              <button class="w3-button w3-green w3-right" style="margin-right:4px;" v-if="stepsObj.step2 && !stepsObj.step3" @click="saveSchedule()">Continue</button>
              <button class="w3-button w3-green w3-right" style="margin-right:4px;" v-if="stepsObj.step3 && !stepsObj.step4" @click="purchaseAd()">
                <template v-if="selectedAd.paid">
                  Save Changes
                </template>
                <template v-if="!selectedAd.paid">
                  Finish & Pay
                </template>
              </button>
            </template>
            <template v-if="ad.placement === 'event'">
              <button class="w3-button w3-green w3-right" style="margin-right:4px;" v-if="stepsObj.step3 && !stepsObj.step4" @click="saveSchedule()">Continue</button>
              <button class="w3-button w3-green w3-right" style="margin-right:4px;" v-if="stepsObj.step4" @click="purchaseAd()">
                <template v-if="selectedAd.paid">
                  Save Changes
                </template>
                <template v-if="!selectedAd.paid">
                  Finish & Pay
                </template>
              </button>
            </template>
          </template>
          
          <div v-if="!stepsObj.step1">
            <div class="sectionHeader" style="text-align:center;">
              <h5>Ad Type</h5>
            </div>
            <div class="w3-row">
              <div class="w3-col s12 m6">
                <div class="adTypeSelectBox whiteContainer w3-display-container animateRight" @click="selectType('global')">
                  <div class="w3-display-middle w3-center w3-block w3-container">
                    <h3>Global / Sitewide Ads</h3>
                    <p style="font-size:12pt">Purchase ads that show on global pages like the Home Page and Event List pages.</p>
                    <p>$49 / month flat rate</p>
                  </div>
                </div>
              </div>
              <div class="w3-col s12 m6">
                <div class="adTypeSelectBox whiteContainer w3-display-container animateLeft" @click="selectType('event')">
                  <div class="w3-display-middle w3-center w3-block w3-container">
                    <h3>Event Specific Ads</h3>
                    <p style="font-size:12pt">Purchase ads for specific event pages like Sports, Charities and Community Events.</p>
                    <p>Cost Varies by Event</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <template v-if="stepsObj.step1">
            <steps :type="ad.placement" :stepsObj="stepsObj" v-if="!showPreview"></steps>
          </template>

          <!-- Step 1 -->
          <div v-if="stepsObj.step1 && !stepsObj.step2">
            <adBuilder :ad="ad" v-on:saveAd="saveAd()"></adBuilder>
          </div>

          <!-- Step 2 -->
          <div v-if="stepsObj.step2 && !stepsObj.step3">
            <template v-if="ad.placement === 'global'">
              <schedule :type="ad.placement" v-on:saveSchedule="saveSchedule"></schedule>
            </template>
            <template v-if="ad.placement === 'event'">
              <eventSearch v-on:showPreview="showPreview = $event" v-on:exit="exit()" v-on:selectEvent="selectEvent()"></eventSearch>
            </template>
          </div>
          
          <!-- Step 3 -->
          <div v-if="stepsObj.step3 && !stepsObj.step4">
            <template v-if="ad.placement === 'global'">
              <billing v-on:selectPayment="selectPayment" v-on:purchaseAd="purchaseAd"></billing>
            </template>
            <template v-if="ad.placement === 'event'">
              <schedule type="event" v-on:saveSchedule="saveSchedule"></schedule>
            </template>
          </div>
          
          <!-- Step 4 -->
          <div v-if="stepsObj.step4">
            <billing v-on:selectPayment="selectPayment" v-on:purchaseAd="purchaseAd" :paymentError="paymentError"></billing>
          </div>
        </div>

        <div v-if="advertisersView === 'event-search'">
          <div class="w3-row">
            <template v-if="eventCategories">
              <eventSearch v-on:exit="exit()"></eventSearch>
            </template>
          </div>
        </div>

      </div>
      <!-- Sidebar -->
      <div class="w3-col s12 m4 animateLeft" v-if="!hideSidebar">
        <template v-if="width > 600">
          <!-- Advertiser Area -->
          <template v-if="user && user.types.advertiser">
            <div class="sectionHeader w3-center">
              <h5>Ad Management</h5>
            </div>
            <div class="whiteContainer" style="margin:0 4px 8px;">
              <button @click="pageNav('ad-input')" class="w3-button w3-block w3-green">
                <span>Start New Ad</span>
              </button>
            </div>
          </template>
        </template>
        
        <userauth type="advertiser"></userauth>

      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import events from '@/components/events.vue'
import adBuilder from '@/components/adBuilder.vue'
import analytics from '@/components/analytics.vue'
import eventSearch from '@/components/eventSearch.vue'
import schedule from '@/components/schedule.vue'
import billing from '@/components/billing.vue'
import steps from '@/components/steps.vue'
import sortFilter from '@/components/sortFilter.vue'
import eventDetail from '@/views/EventDetail.vue'
import axios from 'axios'
import * as moment from 'moment'

export default {
  name: "Advertisers",
  components: {
    adBuilder,
    analytics,
    events,
    sortFilter,
    eventSearch,
    steps,
    schedule,
    billing
  },
  data() {
    return {
      hideSidebar: false,
      eventCategories: true,
      showPreview: false,
      errorMessage: '',
      paymentError: '',
      ad: {
        uid: '',
        id: '',
        email: '',
        placement: '',
        url: '',
        images: {
          inline: '',
          sidebar: '',
          mobile: ''
        },
        title: '',
        text: '',
        button: '',
        start: moment().format(),
        end: moment().add(1, 'month').format(),
        color: 'w3-white',
        buttonColor: 'w3-green',
        billing: {
          firstName: '',
          lastName: '',
          company: '',
          street: '',
          city: '',
          state: '',
          zip: ''
        },
        charges: []
      },
      stepsObj: {
        step1: false,
        step2: false,
        step3: false,
        step4: false,
        step5: false
      },
      width: window.innerWidth
    }
  },
  computed: {
    filteredList() {
      return this.postList.filter(post => {
        var vm = this;
        return post.title.toLowerCase().includes(vm.search.toLowerCase())
      })
    },
    ...mapState([
      'user',
      'userAds',
      'advertisersView',
      'events',
      'selectedEvent',
      'selectedAd',
      'imageUpload'
    ])
  },
  methods: {
    pageNav(page) {
      if (page === 'defaultView' || 'userView') {
        this.hideSidebar = false
      }
      if (page === 'ad-input' || page === 'ad-analytics' || page === 'event-search') {
        this.hideSidebar = true
      }
      this.$store.dispatch('setAdvertisersView', page)
      window.scrollTo(0, 0);
    },
    registerLink() {
      this.$store.dispatch('setAuthView', 'registerView')
      let offset = document.getElementsByClassName("userAreaContainer")[0].offsetTop
      scrollTo(0,offset)
    },
    loginLink() {
      this.$store.dispatch('setAuthView', 'loginView')
      let offset = document.getElementsByClassName("userAreaContainer")[0].offsetTop
      scrollTo(0,offset)
    },
    backStep() {
      if (this.stepsObj.step4) {
        this.stepsObj.step4 = false
        window.scrollTo(0, 0)
        return
      }
      if (this.stepsObj.step3) {
        this.stepsObj.step3 = false
        window.scrollTo(0, 0)
        return
      }
      if (this.stepsObj.step2) {
        this.stepsObj.step2 = false
        window.scrollTo(0, 0)
        return
      }
      if (this.stepsObj.step1) {
        this.stepsObj.step1 = false
        this.ad.placement = ''
        window.scrollTo(0, 0)
        return
      }
    },
    selectType(type) {
      this.ad.placement = type
      this.stepsObj.step1 = true
      this.adPreview = true
    },
    selectEvent() {
      this.ad.eventid = this.selectedEvent.eventid
      this.ad.end = moment(this.selectedEvent.dates[this.selectedEvent.dates.length - 1].date).format()
      this.$store.dispatch('updateAd', this.ad)
      this.$store.dispatch('getActiveAds')
      this.showPreview = false
      this.stepsObj.step3 = true
    },
    saveAd() {
      if (this.ad.title === '') {
        this.errorMessage = 'Need Title'
        setTimeout(() => {this.errorMessage = ''}, 3000)
        return
      }
      if (this.ad.url === '') {
        this.errorMessage = 'Need URL'
        setTimeout(() => {this.errorMessage = ''}, 3000)
        return
      }
      if (!this.imageUpload) {
        if (this.ad.text === '') {
          this.errorMessage = 'Need Text'
          setTimeout(() => {this.errorMessage = ''}, 3000)
          return
        }
        if (this.ad.button === '') {
          this.errorMessage = 'Need Button'
          setTimeout(() => {this.errorMessage = ''}, 3000)
          return
        }
      }
      if (this.ad.placement === 'global') {
        if (!this.ad.billing.paid) {
          if (!this.ad.start) {
            this.ad.start = moment().format()
          }
          if (!this.ad.end) {
            this.ad.end = moment().add(1, 'months').format()
          }
        }
      }
      if (this.ad.placement === 'event') {
        if (!this.ad.start) {
          this.ad.start = moment().format()
        }
        if (!this.ad.end) {
          for (let event of this.events.upcoming) {
            if (event.eventid === this.ad.eventid) {
              this.ad.end = moment(event.dates[event.dates.length - 1].date).format()
              break
            }
          }
        }
      }
      
      if (this.user.contact) {
        if (this.ad.billing) {
          if (this.ad.billing.firstName === "") {this.ad.billing.firstName = this.user.contact.firstName}
          if (this.ad.billing.lastName === "") {this.ad.billing.lastName = this.user.contact.lastName}
          if (this.ad.billing.company === "") {this.ad.billing.company = this.user.contact.company}
          if (this.ad.billing.street === "") {this.ad.billing.street = this.user.contact.street}
          if (this.ad.billing.city === "") {this.ad.billing.city = this.user.contact.city}
          if (this.ad.billing.state === "") {this.ad.billing.state = this.user.contact.state}
          if (this.ad.billing.zip === "") {this.ad.billing.zip = this.user.contact.zip}
        } else {
          this.ad.billing = {
            firstName: this.user.contact.firstName,
            lastName: this.user.contact.lastName,
            company: this.user.contact.company,
            street: this.user.contact.street,
            city: this.user.contact.city,
            state: this.user.contact.state,
            zip: this.user.contact.zip
          }
        }
      } else {
        this.ad.billing = {
          firstName: '',
          lastName: '',
          company: '',
          street: '',
          city: '',
          state: '',
          zip: ''
        }
      }
      this.stepsObj.step2 = true
      this.$store.dispatch('getUserAds', this.user).then(() => {
        if (this.userAds.length) {
          let counter = this.userAds.length
          let found = false
          for (let ad of this.userAds) {
            counter--
            if (ad.id && ad.id !== '') {
              if (ad.id === this.ad.id) {
                found = true
                this.ad.status = 'Pending'
                this.$store.dispatch('updateAd', this.ad).then(() => {
                  this.$store.commit('setSelectedAd', this.ad)
                  this.$store.dispatch('getUserAds', this.user)
                })
              }
            }
            if (counter == 0) {
              if (!found) {
                this.ad.uid = this.user.uid
                this.ad.email = this.user.email
                this.ad.status = 'Pending'
                this.$store.dispatch('addAd', this.ad).then(() => {
                  this.$store.commit('setSelectedAd', this.ad)
                  this.$store.dispatch('getUserAds', this.user)
                })
              }
            }
          }
        } else {
          this.ad.uid = this.user.uid
          this.ad.email = this.user.email
          this.ad.status = 'Pending'
          this.$store.dispatch('addAd', this.ad).then(() => {
            this.$store.dispatch('getUserAds', this.user)
          })
        }
        window.scrollTo(0, 0)
      })
    },
    adAnalytics(id) {
      this.$store.dispatch('getClicksByAd', id).then((result) => {
        let clicks = result
        this.stepsObj.step1 = true
        this.pageNav('ad-analytics')
      })
    },
    editAd(id) {
      this.$store.dispatch('getAdByID', id).then((result) => {
        this.ad = result
        this.$store.commit('setSelectedAd', result)
        this.stepsObj.step1 = true
        if (this.ad.images.inline !== '' || this.ad.images.sidebar !== '' || this.ad.images.mobile !== '') {
          this.$store.commit('setImageUpload', true)
        } else {
          this.$store.commit('setImageUpload', false)
        }
        this.pageNav('ad-input')
      })
    },
    removeAd(ad) {
      if (confirm("Are you sure you want to DELETE the ad for " + ad.title + "?")) {
        this.$store.dispatch('removeAd', ad.id).then(() => {
          this.$store.dispatch('getUserAds', this.user)
        })
      }
    },
    saveSchedule() {
      if (this.ad.placement === 'global') {
        this.ad.billing.cost = 4900
        this.stepsObj.step3 = true
      }
      if (this.ad.placement === 'event') {
        this.stepsObj.step4 = true
      }
      window.scrollTo(0, 0)
    },
    selectPayment() {
      for (let source of this.user.customer.sources.data) {
        if (source.selected) {
          this.ad.billing.source = source.id
        }
      }
      if (this.ad.billing.source) {
        this.$store.dispatch('updateAd', this.ad)
      }
    },
    purchaseAd() {
      if (!this.ad.billing.source) {
        this.paymentError = "Must select a payment source"
        return
      }
      if (this.ad.paid) {
        console.log('already paid')
        this.$store.dispatch('sendEmail', {email: '', type: 'adSubmit'})
        this.exit()
      }
      let source = this.ad.billing.source
      let amount = this.ad.billing.cost
      let created = moment().format()
      
      let customer = ''
      if (this.user.customer) {
        customer = this.user.customer.id
      } else {
        console.log('no customer')
        return
      }
      

      let postData = {
        customer: customer,
        source: source,
        amount: amount,
        type: this.ad.placement,
        start: this.ad.start,
        account: ''
      }
      if (this.ad.eventid && this.ad.placement === 'event') {
        for (let event of this.events.upcoming) {
          if (event.eventid === this.ad.eventid) {
            if (event.payTo && event.payTo !== '') {
              postData.account = event.payTo
              this.$store.dispatch('sendEmail', {email: event.email, type: 'sellerReceipt'})
            } else {
              postData.account = 'acct_1AtGZoEMGjG19Byq'
            }
          }
        }
      } else if (this.ad.placement === 'global') {
        this.$store.dispatch('sendEmail', {email: '', type: 'globalAdSubmit'})
      }

      this.$store.commit('setLoading', true)
      axios.post('https://us-central1-daytona-local.cloudfunctions.net/chargeAd', postData).then((response) => {
        this.$store.commit('setLoading', false)
        if (response.data.status === 'succeeded' && response.data.object === 'charge') {
          this.$store.dispatch('sendEmail', {email: this.user.email, type: 'buyerReceipt'})
          this.ad.paid = true
          if (!this.ad.charges) {
            this.ad.charges = []
          }
          this.ad.charges.push(response.data)
          this.$store.dispatch('updateAd', this.ad).then(() => {
            this.$store.commit('setSelectedAd', this.ad)
            this.$store.dispatch('getUserAds', this.user)
            this.exit()
          })
        } else {
          console.log(response.data.status)
        }
      }).catch((error) => {
        this.$store.commit('setLoading', false)
        console.log(error)
        // this.$store.commit('setLoadingPayMethods', false)
      })
    },
    exit() {
      this.pageNav('userView')
      this.ad = {
        uid: '',
        id: '',
        email: '',
        placement: '',
        url: '',
        images: {
          inline: 'https://firebasestorage.googleapis.com/v0/b/daytona-local.appspot.com/o/example-inline.jpg?alt=media&token=b437a531-509c-446b-91a6-5892ff2652d6',
          sidebar: 'https://firebasestorage.googleapis.com/v0/b/daytona-local.appspot.com/o/example-sidebar.jpg?alt=media&token=6ae9c073-bbfb-47f3-bfc9-aac790bc3f7f',
          mobile: 'https://firebasestorage.googleapis.com/v0/b/daytona-local.appspot.com/o/example-mobile.jpg?alt=media&token=a1cb5807-834a-4380-979a-2e187a04a585'
        },
        title: '',
        text: '',
        button: '',
        start: moment().format(),
        end: moment().add(1, 'month').format(),
        color: 'w3-white',
        buttonColor: 'w3-green',
        billing: {
          firstName: '',
          lastName: '',
          company: '',
          street: '',
          city: '',
          state: '',
          zip: ''
        },
        charges: []
      }
      this.stepsObj.step1 = false
      this.stepsObj.step2 = false
      this.stepsObj.step3 = false
      this.stepsObj.step4 = false
      this.$store.commit('setImageUpload', false)
      this.$store.dispatch('getUserAds', this.user)
      window.scrollTo(0, 0)
    },
    link(link) {
      if (link) {
        if (!/^(f|ht)tps?:\/\//i.test(link)) {
          window.open('//' + link, '_blank');
        } else {
          window.open(link, '_blank')
        }
      } else {
        console.log('no link')
      }
    }
  },
  mounted() {
    if (this.user) {
      this.pageNav('userView')
    } else {
      this.pageNav('defaultView')
    }

    this.$store.dispatch('getUserAds', this.user)
  }
}
</script>
